export const GERMAN = 'DE';
export const ENGLISH = 'EN';
export const TURKISH = 'TR';


// WEBPACK FOOTER //
// ./src/actions/language.js